const SKELETON_SELECTOR = '[data-hm-skeleton]';

function handleImageEvent(event) {
  const target = event.target;
  if (!(target instanceof HTMLImageElement)) return;
  if (target.classList.contains('resource-card__image--secondary')) return;

  const wrapper = target.closest(SKELETON_SELECTOR);
  if (!wrapper) return;

  if (event.type === 'error') {
    wrapper.classList.add('is-error');
    wrapper.classList.remove('is-loaded');
    return;
  }

  wrapper.classList.add('is-loaded');
  wrapper.classList.remove('is-error');
}

document.addEventListener('load', handleImageEvent, true);
document.addEventListener('error', handleImageEvent, true);

document.querySelectorAll(`${SKELETON_SELECTOR} img`).forEach((img) => {
  if (img.complete && img.naturalWidth > 0) {
    img.closest(SKELETON_SELECTOR)?.classList.add('is-loaded');
  }
});
